import { render, staticRenderFns } from "./daka-history.vue?vue&type=template&id=c0eda8ce&scoped=true"
import script from "./daka-history.vue?vue&type=script&lang=js"
export * from "./daka-history.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c0eda8ce",
  null
  
)

export default component.exports